import React from 'react';

import {
  AppLayout
} from 'AWS-UI-Components-React';

import {
  BeerTable
} from './beer_table'



const Content = () => (
  <div className='awsui-grid awsui-util-p-s'>
    <div className='custom-home__header custom-awsui-util-pt-xxxl awsui-row'>
      <div className='col-xxs-12'>
        <div className='awsui-row'>
          <div className='custom-home__header-title col-xxs-10 offset-xxs-1 col-s-6 col-l-5 offset-l-2 col-xl-6'>
            <div className='awsui-text-large'>
              <div><strong>Beers</strong></div>
            </div>

            <div className='beersTable'>
                <BeerTable />
            </div>

          </div>
        </div>
      </div>
    </div>
    <div className='awsui-util-pt-xxl awsui-row'>
      <div className='col-xxs-10 offset-xxs-1 col-s-6 col-l-5 offset-l-2 col-xl-6'>

      </div>
      <div className='custom-home__sidebar col-xxs-10 offset-xxs-1 col-s-4 offset-s-0 col-l-3 col-xl-2'>
        <div className='awsui-util-mt-xxl'>
          <div className='awsui-util-container'>
            <div className='awsui-util-container-header'>
              <h2>Getting started!</h2>
            </div>
            <div>
              <div className='custom-inner-table-row'>
                <a href='https://polaris.corp.amazon.com/'>
                  Polaris Docs
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export class Main extends React.Component {

  render() {
    return (
      <div className="awsui">
        <AppLayout
                  className='awsui-util-no-gutters'
                  content={<Content/>}
                  navigationHide={true}
                  toolsHide={true}
                />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/main.jsx